import styled from "styled-components";
import theme from "../../theme";
import { Nok } from "../../types/types";
import InputField from "./inputField";
import { Button } from "../common/Button";
import { ModalLayout } from "../common/ModalLayout";
import { useWindowSize } from "@reactuses/core";
import { useI18n } from "../../locales";

const { md } = theme.screen;

const NokDetailModal: React.FC<{
  data: Nok;
  open: boolean;
  onPressNo: () => void;
  onClickModify: () => void;
}> = (props) => {
  const { open, data, onPressNo, onClickModify } = props;
  const { width } = useWindowSize();
  const { t } = useI18n();

  return (
    <ModalLayout
      open={open}
      onClose={onPressNo}
      width="550px"
      title={t.manageNok.detailInfoTitle}
    >
      <InputField data={data} />

      <BtnWrapper>
        <Button
          onClick={() => {
            onPressNo(); // 현재 모달 닫음
            onClickModify(); // 수정하기 모달 표출
          }}
          bgColor={theme.statusColor.MAIN}
          hoverColor={theme.statusColor.MAIN_HOVER}
        >
          {width <= md ? t.common.edit : t.manageNok.editInfoTitle}
        </Button>
        <Button
          bgColor={theme.statusColor.CLOSE}
          onClick={onPressNo}
          hoverColor={theme.statusColor.CLOSE_HOVER}
        >
          {t.common.close}
        </Button>
      </BtnWrapper>
    </ModalLayout>
  );
};

const BtnWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 20px;
  margin: 0 50px;
  margin-top: 20px;

  button {
    width: 270px;
  }
  @media (max-width: ${md}px) {
    margin: 0px;
    margin-top: 20px;
  }
`;

export default NokDetailModal;
